<script>
import {h} from 'vue';
import ArticleChuckAbout from '@/components/article/ArticleChuckAbout.vue';
import ArticleChuckContact from '@/components/article/ArticleChuckContact.vue';
import ArticleChuckHero from '@/components/article/ArticleChuckHero.vue';
import ArticleContact from '@/components/article/ArticleContact.vue';
import ArticleCookies from '@/components/article/ArticleCookies.vue';
import ArticleCookiesAnalytical from '@/components/article/ArticleCookiesAnalytical.vue';
import ArticleCookiesNecessary from '@/components/article/ArticleCookiesNecessary.vue';
import ArticleCookiesVideo from '@/components/article/ArticleCookiesVideo.vue';
import ArticleCookiesWhatAre from '@/components/article/ArticleCookiesWhatAre.vue';
import ArticleHome from '@/components/article/ArticleHome.vue';
import ArticleHomeCourse from '@/components/article/ArticleHomeCourse.vue';
import ArticleHomePrivates from '@/components/article/ArticleHomePrivates.vue';
import ArticleHomeShoes from '@/components/article/ArticleHomeShoes.vue';
import ArticleHomeWhat from '@/components/article/ArticleHomeWhat.vue';
import ArticleHomeWhy from '@/components/article/ArticleHomeWhy.vue';
import ArticlePrivacy from '@/components/article/ArticlePrivacy.vue';
import ArticlePrivatesContact from '@/components/article/ArticlePrivatesContact.vue';
import ArticlePrivatesHero from '@/components/article/ArticlePrivatesHero.vue';
import ArticleShoesAlex from '@/components/article/ArticleShoesAlex.vue';
import ArticleShoesSwayd from '@/components/article/ArticleShoesSwayd.vue';
import ArticleTerms from '@/components/article/ArticleTerms.vue';
import ArticleVideos from '@/components/article/ArticleVideos.vue';

export default {
    // https://stackoverflow.com/questions/70957780/how-i-can-render-a-component-from-a-string-with-vue-3
    props: {
        html: {
            type: String,
            default: '',
        },
    },
    render() {
        const r = {
            components: {
                ArticleChuckAbout,
                ArticleChuckContact,
                ArticleChuckHero,
                ArticleContact,
                ArticleCookies,
                ArticleCookiesAnalytical,
                ArticleCookiesNecessary,
                ArticleCookiesVideo,
                ArticleCookiesWhatAre,
                ArticleHome,
                ArticleHomeCourse,
                ArticleHomePrivates,
                ArticleHomeShoes,
                ArticleHomeWhat,
                ArticleHomeWhy,
                ArticlePrivacy,
                ArticlePrivatesContact,
                ArticlePrivatesHero,
                ArticleShoesAlex,
                ArticleShoesSwayd,
                ArticleTerms,
                ArticleVideos,
            },
            template: `
                <div class="content-compiled">${this.html || ''}</div>`,
            /**
            methods: {
                hello () {
                    // method "hello" is also available here
                },
            },
            **/
        };
        return h(r);
    },
};
</script>
